import { HOME } from "../constants";

const initialState = {
  totalAssetStats: {
    denchu: "-",
    hh: "-",
    mh: "-",
  },
  homeImageData: [],
  totalImageCount: "--",
  currentPageNumber: 1,
  filteredTotal: "--",
  filter: {
    type: "occurred_datetime",
    order: "desc",
    tag: [],
    filterType: "photo",
    assetId: null,
    signNumber: null,
    assetType: "all",
    manageGroup: {
      key: "all",
      value: [],
    }
  },
  homeImageDataNtt: [],
  filterNtt: {
    type: "occurred_datetime",
    order: "desc",
    tag: [],
    filterType: "photo",
    assetId: null,
    assetType: "all",
    prefecturalArea: "all",
    exchangeOfficeName: "all",
    photoType: "all",
    twoStepVerification: "all",
    resultTag: "all",
  },
  homeImageDataHokuden: [],
  filterHokuden: {
    type: "occurred_datetime",
    order: "desc",
    tag: [],
    filterType: "photo",
    assetId: null,
    assetType: "all",
    powerAssetNumber: null,
    // areaName: "all",
    username: "all",
    municipality: "all",
    branchName: "all",
    resultTag: "all",
  },
  hokudenOptionCity: [],
  hokudenOptionBranch: [],
};

export default function homeReducer(state = initialState, action) {
  switch (action.type) {
    case HOME.SET_TOTAL_STATS_DATA:
      return {
        ...state,
        totalAssetStats: action.payload,
      };
    case HOME.SET_HOME_IMAGE_DATA:
      return {
        ...state,
        homeImageData: action.payload,
      };
    case HOME.SET_TOTAL_IMAGE_COUNT:
      return {
        ...state,
        totalImageCount: action.payload,
      };
    case HOME.SET_CURRENT_PAGE_NUMBER:
      return {
        ...state,
        currentPageNumber: action.payload,
      };
    case HOME.SET_FILTERED_TOTAL:
      return {
        ...state,
        filteredTotal: action.payload,
      };
    case HOME.SET_FILTER:
      return {
        ...state,
        filter: action.payload,
      };
    case HOME.SET_HOME_IMAGE_DATA_NTT:
      return {
        ...state,
        homeImageDataNtt: action.payload,
      };
    case HOME.SET_FILTER_NTT:
      return {
        ...state,
        filterNtt: action.payload,
      };
  case HOME.SET_HOME_IMAGE_DATA_HOKUDEN:
    return {
      ...state,
      homeImageDataHokuden: action.payload,
    };
  case HOME.SET_FILTER_HOKUDEN:
    return {
      ...state,
      filterHokuden: action.payload,
    };
  case HOME.SET_HOKUDEN_OPTION_CITY:
    return {
      ...state,
      hokudenOptionCity: action.payload,
    };
  case HOME.SET_HOKUDEN_OPTION_BRANCH:
    return {
      ...state,
      hokudenOptionBranch: action.payload,
    };
    default:
      return state;
  }
}
